import { render, staticRenderFns } from "./cancellation.vue?vue&type=template&id=c45ea05a&scoped=true"
import script from "./cancellation.vue?vue&type=script&lang=js"
export * from "./cancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45ea05a",
  null
  
)

export default component.exports